import { CheckCircle2 } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function CountryProcessSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Admission Roadmap"
          title="A Clear Step-by-Step Process"
          description="Every stage is structured so you and your family can make informed decisions without confusion."
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {country.process.map((step, index) => (
            <article
              key={step.title}
              className="relative signature-card signature-card-interactive rounded-2xl p-5"
            >
              <div className="mb-3 flex items-center justify-between">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-midnight-navy text-xs font-semibold text-soft-white">
                  {index + 1}
                </span>
                <CheckCircle2 className="h-4 w-4 text-royal-blue" aria-hidden="true" />
              </div>
              <h3 className="text-xl leading-tight">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-text/80">{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryProcessSection;
